<template>
  <header class="app-header">
    <div class="header-left">
      <h1 class="page-title">{{ pageTitle }}</h1>
      <p v-if="pageDesc" class="page-desc">{{ pageDesc }}</p>
    </div>

    <div class="header-right">
      <el-input
        v-model="keyword"
        class="header-search"
        placeholder="搜索客户 / 订单 / 电话"
        clearable
        @keyup.enter.native="onSearch"
      >
        <i slot="prefix" class="el-input__icon el-icon-search" />
      </el-input>

      <el-badge :value="notifyCount" :max="99" class="header-badge">
        <button type="button" class="icon-btn notify-btn" title="通知">
          <i class="el-icon-bell" />
        </button>
      </el-badge>

      <button type="button" class="icon-btn help-btn" title="帮助">
        <span class="help-mark">?</span>
      </button>

      <div class="user-info">
        <el-avatar :size="36" class="user-avatar">{{ avatarText }}</el-avatar>
        <div class="user-meta">
          <div class="user-name">{{ user.name }}</div>
          <div class="user-role">{{ user.role }}</div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppHeader',
  data() {
    return {
      keyword: ''
    }
  },
  computed: {
    ...mapState(['user', 'notifyCount']),
    pageTitle() {
      return (this.$route.meta && this.$route.meta.title) || '外勤蜂'
    },
    pageDesc() {
      return (this.$route.meta && this.$route.meta.desc) || ''
    },
    avatarText() {
      return (this.user.name || '').slice(0, 1)
    }
  },
  methods: {
    onSearch() {
      this.$emit('search', this.keyword.trim())
    }
  }
}
</script>

<style scoped>
.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  height: 64px;
  padding: 0 24px;
  background: #fff;
  border-bottom: 1px solid #eef2f5;
  box-sizing: border-box;
}

.header-left {
  display: flex;
  align-items: baseline;
  gap: 12px;
  min-width: 0;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1f2329;
  white-space: nowrap;
}

.page-desc {
  margin: 0;
  font-size: 13px;
  color: #86909c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.header-search {
  width: 240px;
}

.header-search >>> .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-radius: 999px;
  border-color: #e5e6eb;
  background: #fff;
  padding-left: 36px;
}

.header-search >>> .el-input__inner:focus {
  border-color: #2aa89a;
}

.header-search >>> .el-input__prefix {
  left: 8px;
}

.header-search >>> .el-input__icon {
  line-height: 36px;
  color: #c0c4cc;
}

.header-badge >>> .el-badge__content {
  border: none;
  background: #f56c6c;
  height: 16px;
  line-height: 16px;
  padding: 0 4px;
  top: 4px;
  right: 10px;
}

.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
}

.notify-btn .el-icon-bell {
  font-size: 22px;
  color: #e6a23c;
}

.help-btn {
  border: 1.5px solid #c0c4cc;
  border-radius: 50%;
  width: 22px;
  height: 22px;
}

.help-mark {
  font-size: 14px;
  color: #909399;
  line-height: 1;
  font-weight: 600;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 4px;
}

.user-avatar {
  background: #7eb6ff;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.user-meta {
  line-height: 1.3;
}

.user-name {
  font-size: 14px;
  color: #1f2329;
  font-weight: 500;
}

.user-role {
  font-size: 12px;
  color: #86909c;
}
</style>
